import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { Tooltip } from '../../../../../common/tooltip'
import { formatText } from '../../../../../helpers/value'
import { GDP_TAB } from '../constant'
import classes from './index.module.scss'

export const TabCommon = ({ tab, baseYear, onClick }) => {
  return (
    <div className="dFlex">
      {Object.values(GDP_TAB).map((item) => (
        <Element
          key={item.key}
          className={classes.item}
          style={
            item.key === tab
              ? {
                  color: '#ffffff',
                  backgroundColor: '#2C73E8',
                }
              : {
                  color: '#191D25',
                  backgroundColor: '#ebebeb',
                }
          }
          onClick={() => onClick(item)}
        >
          <div className="dFlex textCenter">
            <Translate value={item.label} />
            <Tooltip
              isI18n
              contentStyle={{ marginLeft: 4 }}
              translateProps={{ year: formatText(baseYear) }}
              tooltipContent={
                GDP_TAB.REAL_GDP.key === item.key
                  ? 'industryOverview.macroeconomics.TOOLTIP_REAL_GDP'
                  : 'industryOverview.macroeconomics.TOOLTIP_NOMINAL_GDP'
              }
            >
              <Icon
                className="icon-info-circle"
                style={{
                  fontSize: 10,
                  color: tab === item.key ? '#FFFFFF' : '#9C9C9C',
                }}
              />
            </Tooltip>
          </div>
        </Element>
      ))}
    </div>
  )
}

TabCommon.propTypes = {
  tab: PropTypes.string.isRequired,
  baseYear: PropTypes.number,
  onClick: PropTypes.func,
}

TabCommon.defaultProps = {
  onClick: () => {},
}
